import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [localAuth, setLocalAuth] = useState<boolean | null>(null);
  const [localLoading, setLocalLoading] = useState(true);

  // Verificação adicional para lidar com casos de navegação entre ambientes
  useEffect(() => {
    const checkLocalStorage = () => {
      try {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          try {
            const parsedUser = JSON.parse(storedUser);
            if (parsedUser && parsedUser.id) {
              console.log('✅ ProtectedRoute: Usuário encontrado no localStorage');
              setLocalAuth(true);
            } else {
              setLocalAuth(false);
            }
          } catch (e) {
            console.warn('⚠️ ProtectedRoute: Erro ao analisar usuário do localStorage:', e);
            setLocalAuth(false);
          }
        } else {
          setLocalAuth(false);
        }
      } catch (e) {
        console.warn('⚠️ ProtectedRoute: Erro ao acessar localStorage:', e);
        setLocalAuth(false);
      } finally {
        setLocalLoading(false);
      }
    };

    // Verifica localStorage apenas se o AuthContext indicar que não está autenticado
    // Isso ajuda a lidar com casos onde a sessão pode ter sido perdida entre ambientes
    if (!loading) {
      if (!isAuthenticated) {
        console.log('⚠️ ProtectedRoute: AuthContext indica não autenticado, verificando localStorage...');
        checkLocalStorage();
      } else {
        setLocalAuth(true);
        setLocalLoading(false);
      }
    }
  }, [isAuthenticated, loading]);

  // Mostra loading enquanto ambas as verificações estão em andamento
  if (loading || localLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
        <div className="spinner-border" role="status" aria-label="Carregando" />
        <span className="sr-only" style={{ marginLeft: 12 }}>Carregando...</span>
      </div>
    );
  }

  // Se não estiver autenticado pelo AuthContext nem pelo localStorage
  if (!isAuthenticated && !localAuth) {
    console.log('❌ ProtectedRoute: Usuário não autenticado em nenhuma verificação');
    // Show an explicit message instead of redirecting so users understand they must log in
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ maxWidth: 760, width: '100%', textAlign: 'center', background: 'var(--card-bg, #fff)', padding: 24, borderRadius: 8, boxShadow: '0 6px 18px rgba(0,0,0,0.08)' }}>
          <h2 style={{ marginBottom: 12 }}>Acesso restrito</h2>
          <p style={{ marginBottom: 18 }}>Você precisa estar autenticado para acessar esta área. Por favor faça login para continuar.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <button className="btn btn-outline" onClick={() => navigate('/login', { state: { from: location } })}>Ir para o Login</button>
            <button className="btn btn-primary" onClick={() => navigate('/')}>Voltar</button>
          </div>
        </div>
      </div>
    );
  }

  // Se estiver autenticado por qualquer um dos métodos
  console.log('✅ ProtectedRoute: Acesso permitido');
  return children;
};

export default ProtectedRoute;

